import React, { useCallback } from 'react';

// DEPENDENCIES
import clsx from 'clsx';
import { useFormikContext } from 'formik';

// GLOBAL VARIABLES
import { SORT_ORDER } from 'globals.js';

// GLOBAL FUNCTIONS
import { doCallback } from 'functions';

// CORE COMPONENTS
import Form from 'core/form/Form';

// LOCAL COMPONENTS
import FilterButton from './FilterButton';

// STYLES
import styles from './sortButton.module.scss';

// MAIN COMPONENT
const SortButton = ({
  className,
  label,
  onUpdate,
  disabled,
}) => {

  // FORMIK CONTEXT
  const { values, setFieldValue } = useFormikContext() || {};
  const { order } = values;
  
  // CALLBACKS
  const handleUpdate = useCallback(
    update => {
      doCallback(setFieldValue, 'order', update.order);
      doCallback(onUpdate, update);
    },
    [onUpdate, setFieldValue]
  )

  // RENDER
  return (
    <Form.Col>
      <FilterButton
        className={clsx(styles.button, className)}
        variant="primary"
        name="order"
        label={label}
        value={order === SORT_ORDER.ascending ? SORT_ORDER.descending : SORT_ORDER.ascending}
        icon={order === SORT_ORDER.ascending ? 'arrow-up' : 'arrow-down'}
        onUpdate={handleUpdate}
        disabled={disabled}
        fullWidth={false}
        outline={false}
      />
    </Form.Col>
  )
}

// EXPORT
export default SortButton;
